import {NgModule} from '@angular/core';
import {ReportingComponentDefinitionModule} from './report-component-definition/reportingComponentDefinition.module';
import {ReportingComponentModule} from './report-component/reportingComponent.module';
import {ReportingReportModule} from './report/reportingReport.module';
import {ReportDefinitionModule} from './report-definition/reportDefinition.module';
import {ReportingAccountComponentModule} from './report-account-component/reportingAccountComponent.module';
import {ReportTemplateModule} from './report-template/reportTemplate.module';

@NgModule({
    imports: [
        ReportingComponentDefinitionModule,
        ReportingComponentModule,
        ReportingAccountComponentModule,
        ReportingReportModule,
        ReportDefinitionModule,
        ReportTemplateModule,
    ]
})
export class ReportingModule {
}
